import React from 'react';
import { Divider, Typography } from '@material-ui/core';
import { useApiUrl } from '../../../../../../../../global/config/useApiUrl';
import { useCampfireFetch } from '../../../../../../../../global/network/useCampfireFetch';
import { ReactComponent as SalesforceIcon } from '../../../../../../../../assets/icons/salesforce.svg';
import { useStyles } from '../styles';

const SALESFORCE_CODE_VERIFIER_KEY = 'salesforce_code_verifier';

function generateCodeVerifier(): string {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return Array.from(array, (byte) => byte.toString(16).padStart(2, '0')).join('');
}

async function generateCodeChallenge(verifier: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const hash = await crypto.subtle.digest('SHA-256', data);
  const base64 = btoa(String.fromCharCode(...new Uint8Array(hash)));
  return base64
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

export function SalesforceAuthorizationRequest() {
  const [salesforceUrl, setSalesforceUrl] = React.useState<string | undefined>();
  const campfireFetch = useCampfireFetch<{ url: string }>({ defer: true });
  const apiUrl = useApiUrl();

  React.useEffect(() => {
    const initAuth = async () => {
      const codeVerifier = generateCodeVerifier();
      const codeChallenge = await generateCodeChallenge(codeVerifier);

      sessionStorage.setItem(SALESFORCE_CODE_VERIFIER_KEY, codeVerifier);

      const response = await campfireFetch.run({
        url: `${apiUrl}/wm/auth/uri?app=salesforce&codeChallenge=${encodeURIComponent(codeChallenge)}`,
        method: 'get',
      });

      setSalesforceUrl(response.data.data.url);
    };

    initAuth();
  }, []);

  const classes = useStyles();

  if (salesforceUrl) {
    return (
      <a className={classes.button} href={salesforceUrl} style={{ padding: '7px 12px' }}>
        <SalesforceIcon />
        <Divider orientation='vertical' style={{ height: '1.5rem', marginLeft: '4px', backgroundColor: '#fff' }} />
        <Typography
          style={{
            marginLeft: '4px',
            fontWeight: 600,
            fontSize: '13px',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          }}
        >
          Login with Salesforce
        </Typography>
      </a>
    );
  }

  return null;
}
